export let defaultScreenSizeConfig = {
    "desktop": {
        "total": {
            "width": 2778,
            "height": 2778
        },
        "safe": {
            "width": 1920,
            "height": 1080
        },
        "scaleFactor": 1
    },
    "mobile": {
        "portrait": {
            "total": {
                "width": 2778,
                "height": 2778
            },
            "safe": {
                "width": 1200,
                "height": 1200
            },
            "scaleFactor": 0.6
        },
        "landscape": {
            "total": {
                "width": 2778,
                "height": 2778
            },
            "safe": {
                "width": 1920,
                "height": 1060
            },
            "scaleFactor": 0.6
        },
        "maxZoom": 0.95,
        "zoomSpeed": 0.25
    }
};